import { RegistrationData } from 'src/types/supplierregistration';

interface RegistrationTrackingContext {
  currentComponent?: string;
  isRegistration: boolean;
  memberId?: number | string;
  source: string;
}

const toJsonString = (payload: unknown): string => {
  try {
    return JSON.stringify(payload);
  } catch {
    return '';
  }
};

export const getRegistrationTrackingDimensions = (
  registrationData: Partial<RegistrationData> | undefined,
  context: RegistrationTrackingContext,
) => {
  const registrationSnapshot = registrationData
    ? {
        companyName: registrationData.companyName || '',
        currentComponent: context.currentComponent || '',
        emailAddress: registrationData.emailAddress || '',
        freeAgency: registrationData.freeAgency || '',
        freeAgencyName: registrationData.freeAgencyInfo?.agencyName || '',
        hasBillingAddress: Boolean(registrationData.billingAddress),
        hasCompanyAddress: Boolean(registrationData.companyAddress),
        hasMainContact: Boolean(registrationData.mainContact),
        memberId: registrationData.memberId || context.memberId || '',
        selectedTags: registrationData.selectedTags || [],
        subscriptionData:
          registrationData?.subscriptionData?.map(product => ({
            productId: product.productId,
            productName: product.productName,
            productType: product.productType,
          })) || [],
        subscriptions: registrationData.subscriptions || {},
      }
    : undefined;

  return {
    currentComponent: context.currentComponent || '',
    flowCommodityCount: registrationData?.commodityIds?.length || 0,
    flowCompanyName: registrationData?.companyName || '',
    flowEmailAddress: registrationData?.emailAddress || '',
    flowMemberId: context.memberId || registrationData?.memberId || '',
    flowProductCount: registrationData?.subscriptionData?.length || 0,
    flowSelectedTagCount: registrationData?.selectedTags?.length || 0,
    isRegistration: context.isRegistration,
    registrationFlowSnapshot: registrationSnapshot ? toJsonString(registrationSnapshot) : '',
    source: context.source,
  };
};
